import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "../ui/separator";
import { StepperType } from "./type";
import "./style.css";

export function Stepper({ steps, onStepChange, currentStep }: StepperType) {
  return (
    <Tabs defaultValue={steps[currentStep].id} onValueChange={onStepChange}>
      <TabsList className="aero:grid aero:w-full aero:grid-cols-3 aero:bg-transparent">
        {steps.map((step, index) => (
          <div key={step.id} className="flex">
            <div className="aero:flex aero:flex-row aero:gap-2">
              <TabsTrigger
                value={step.id}
                className={`
                aero:!rounded-full aero:h-6 aero:w-6 aero:text-xs 
                aero:data-[state=active]:border
                aero:data-[state=active]:border-blue-500
                aero:data-[state=active]:py-0.5
               ${
                 index <= currentStep
                   ? "aero:bg-[#2563EB] aero:text-white"
                   : "aero:bg-gray-100 aero:text-gray-600"
               }`}
              >
                {index + 1}
              </TabsTrigger>
              <span className="aero:flex aero:items-center aero:text-xs aero:text-gray-600 aero:w-1/2 aero:text-wrap">
                {step.title}
              </span>
            </div>

            {index !== steps.length - 1 && (
              <div className="aero:flex aero:justify-center aero:items-center aero:w-full">
                <Separator className="aero:w-1/2 aero:mx-4 aero:border-t aero:border-gray-300" />
              </div>
            )}
          </div>
        ))}
      </TabsList>
    </Tabs>
  );
}
